import { StyledButton } from "Globals/Styles/ButtonStyles";
import styled from "styled-components";

export const StyledAddButton = styled(StyledButton)`
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    padding: 0px;
    margin: 0 0 1px 0;
`;
